import { Lesson } from "./Lessons";
import User from "./User";

export type Solution = {
  id: string;
  state: SolutionState;
  issue: string;
  summary: string;
  mitigation: string;
  measures: object;
  lessons: Lesson[];
  created_at: number;
  updated_at: number;
  target_at: number;
  resolved_at: number;
  url: string;
  owner?: User;
}

export enum SolutionState {
  draft = 25,
  assigned = 50,
  defined = 75,
  resolved = 100
}